/** The `IconColor--{color}` class binding a smart icon applies to its FaIcon. */
export const iconColorClass = (color?: string): Record<string, boolean> => ({
  [`IconColor--${color}`]: Boolean(color)
});

/** The floating-vue tooltip binding shape shared by the intrusion smart icons. */
export const smartIconTooltip = (content: string): { triggers: string[]; content: string } => ({
  triggers: ['click', 'hover', 'focus'],
  content
});
